"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JumpLinks_1 = require("./JumpLinks");
exports.default = JumpLinks_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/JumpLinks/index.js
// module id = 1843
// module chunks = 8